var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"prime-enroll-header"},[_c('img',{staticClass:"prime-logo-enrollment",attrs:{"src":require("../../assets/logo.svg")}}),_c('h2',{staticClass:"text-center pad-lr-ten"},[_vm._v(_vm._s(_vm.title))]),(!_vm.isApproval)?_c('p',{staticClass:"pad-lr-ten text-muted"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }